import React, {useState, useEffect} from 'react'
import { useTranslation } from 'react-i18next'
import ApiGo from '../../../actions/ApiGo'
import Abnormalboth, { Abnormaldiscon, Abnormalsignal } from './Abnormal_card'
import RowBarNode from './RowBarNode'
import { useDispatch, useSelector } from 'react-redux'
import { ADD_RESIDENTS_ARRAY } from '../../../stores/reducer_residentsArray'

const type_Bool=true

// mozilla ver 5.0
// const Mozilla_regex = /(?<=Mozilla\/5\.0\ \().*?(?=\))/


const low_signal_highlight_standard = 7
const disconnect_standard = 7
const MainPage =(props)=>{

    const {t} = useTranslation()

    let content={
        header:["ADMIN.INDEX.DEVICE",'ADMIN.INDEX.SYSTEM_REBOOT'],
        hos:['機構A'],
        // node_title:[["ADMIN.INDEX.WIFI_STRENGTH", "ADMIN.INDEX.PADS_STATUS"], 'wifi ssid', "ADMIN.INDEX.PADS_TYPE",  ["GLOBAL.BED_NO", "GLOBAL.NAME"], ["ADMIN.INDEX.PAD_LEFT","ADMIN.INDEX.PAD_RIGHT", "ADMIN.INDEX.PAD_down"], "ADMIN.INDEX.RSSI", "ADMIN.INDEX.BAD_SIGNAL", "ADMIN.INDEX.DISCONNECTION", "ADMIN.INDEX.RECONNECTION_TIME", "ADMIN.INDEX.UPDATED_TIME", "RESIDENTS.DELETE"],
        // node_title:[["ADMIN.INDEX.WIFI_STRENGTH", "ADMIN.INDEX.PADS_STATUS"], 'wifi ssid', "ADMIN.INDEX.PADS_TYPE",  ["GLOBAL.BED_NO", "GLOBAL.NAME"], "NAV_BAR.PADS", "ADMIN.INDEX.RSSI", "ADMIN.INDEX.BAD_SIGNAL", "ADMIN.INDEX.DISCONNECTION", "ADMIN.INDEX.RECONNECTION_TIME", "ADMIN.INDEX.UPDATED_TIME", "RESIDENTS.DELETE"],
        node_title:[["ADMIN.INDEX.WIFI_STRENGTH", "ADMIN.INDEX.PADS_STATUS"], 'wifi ssid', ["GLOBAL.BED_NO", "GLOBAL.NAME"], "NAV_BAR.PADS", "ADMIN.INDEX.RSSI", "ADMIN.INDEX.BAD_SIGNAL", "ADMIN.INDEX.DISCONNECTION", "ADMIN.INDEX.RECONNECTION_TIME", "ADMIN.INDEX.UPDATED_TIME", "RESIDENTS.DELETE"],
        restart_title:['ADMIN.INDEX.SYSTEM_REBOOT_TIME']
    }
    const _NOW_TIME = new Date()
    const _NOW_TIME_TXT = ((_NOW_TIME.getHours()/10>=1)?_NOW_TIME.getHours():`0${_NOW_TIME.getHours()}`) + ":00"
    const _ONE_HOUR_TXT = ((_NOW_TIME.getHours()===0)?23:(_NOW_TIME.getHours()/10>=1)?_NOW_TIME.getHours()-1:`0${_NOW_TIME.getHours()-1}`) + ":00"
    const [abnormal_discon, setAbnormal_discon] = useState([]);
    const [abnormal_both, setAbnormal_both] = useState([]);
    const [abnormal_signal, setAbnormal_signal] = useState([]);
    const [SystemInfo, setSystemInfo] = useState([]);
    const [RSSI_Info, setRSSI_Info] = useState([]);
    const [refresh, setRefresh] = useState(true);

    const dispatch = useDispatch()

    useEffect(() => {
        ApiGo.getLast_system_restart_time()
        .then(res=>{ if(typeof(res)==='string'){ setSystemInfo(res) } })
        .catch(err=>{ console.log(err); })
    }, []);
    function refresh_rssi(){
        ApiGo.postCal_RSSI_calculation()
        .then((res)=>{console.log(res);setRefresh(true)})
        .catch(err=>{console.log(err);})
    }
    useEffect(()=>{
        if(refresh){
            Promise.all([ApiGo.getMacs_rssi_all(), ApiGo.getResidents().catch(err => {
                return [];
            })])
            .then(res=>{
                dispatch(ADD_RESIDENTS_ARRAY(res[1]))
                let _arr = []
                _arr = res[0].map(bed=>{
                    res[1].forEach(resident =>{
                        if(resident.mac_left === bed.mac){
                        bed = {...resident, ...bed }
                        }else{return}
                    })
                    return bed
                })
                setRSSI_Info(_arr)
            })
            .catch(err=>{console.log(err);})
            setRefresh(false)
        }
    }, [refresh])

    useEffect(()=>{
        setAbnormal_discon(RSSI_Info.filter(title=>{
            return (title.rssi_count<low_signal_highlight_standard)&&(title.offline_count>=disconnect_standard)
        }))
        setAbnormal_both(RSSI_Info.filter(title=>{
            return (title.rssi_count>=low_signal_highlight_standard)&&(title.offline_count>=disconnect_standard)
        }))
        setAbnormal_signal(RSSI_Info.filter(title=>{
            return (title.rssi_count>=low_signal_highlight_standard)&&(title.offline_count<disconnect_standard)
        }))
    }, [RSSI_Info])

    return(
        <div className="of-auto font-l">
            {/* highlight */}
            <div className={`fx-d-r ${(abnormal_both.length!==0)||(abnormal_discon.length!==0)||(abnormal_signal.length!==0)?"margb-xxs":""}`}>
                {abnormal_both.map((title,index)=>{
                    return <Abnormalboth title={title} index={index} key={index}/>
                })}
                {abnormal_discon.map((title,index)=>{
                    return <Abnormaldiscon title={title} index={index} key={index}/>
                })}
                {abnormal_signal.map((title,index)=>{
                    return <Abnormalsignal title={title} index={index} key={index} />
                })}
            </div>
            {/* node */}
            <div className='wid-admin-90 fx-d-r fx-fec'>
                <div className='fx-ccc font-m bgC-alert-E pad-5 l b r t cursor pt br-10 shadow-xs margb-xxxs LRefresh' onClick={refresh_rssi}>
                    <div className='tag search fx-cspar font-ml pad-5 l r'>
                        <div className='refreshFrame'>
                            <div className='layoutRefresh_sass clickRotate fx-d-r'>
                                <div className="reloadSingle"></div>
                            </div>
                        </div>
                    </div>
                    {t("ADMIN.INDEX.REFRESH")}
                </div>
            </div>
            <div className="fx-d-c bgC-white wid-admin-90 hig-auto br-20 shadow-s-noHover pad-15 t b">
                <div className='fx-d-r h-100 fx-nsbfe'>
                    <div className="margl-xxs fx-d-r fx-fsc">{t(content.header[0])}</div>
                    <div className='fx-ccc font-m margr-s'>{t("ADMIN.INDEX.RECORDING TIME")} : {_ONE_HOUR_TXT} - {_NOW_TIME_TXT}</div>
                </div>
                <div className="fx-d-r font-m fx-cspar wid-admin-90 hig-s">
                    {content.node_title.map((title, index)=>{
                        // 連線狀態 + RSSI值 欄位
                        if(index===0){ return <div className={`fx-d-c fx-cc wid-admin-8s unselc default hover_explaintion exp_${index}`} key={index}><div>{t(title[0])}</div><div>{t(title[1])}</div></div>}
                        // else if(index===4){ return <div className="fx-d-c fx-ccc wid-admin-s unselc default" key={index}><div>{t(title[0])}</div><div>{t(title[1])}</div><div>{t(title[2])}</div></div>}
                        else if(index===3){ return <div className={`fx-cc wid-admin-s unselc default hover_explaintion exp_${index}`} key={index}>{t(title)}</div>}
                        else if(index===2){ return <div className="fx-d-c fx-cc wid-admin-xs unselc default" key={index}><div className="fx-d-r fx-cspar"><div>{t(title[0])}</div>/<div>{t(title[1])}</div></div><div>{title[2]}</div></div>}
                        return <div className={`fx-cc margr-xs wid-admin-xs unselc default hover_explaintion exp_${index}`} key={index}>{t(title)}</div>
                    })}
                </div>
                <div className="wid-admin-90 fx-d-c fx-cc ">
                    {/* row bar for wifi */}
                        {RSSI_Info.map((data,index)=>{ return <RowBarNode data={data} type_Bool={type_Bool} key={index} setRefresh={setRefresh}/>})}
                </div>
            </div>

            {/* restart time */}
            <div className="margt-xxs">
                <div>{t(content.header[1])}</div>
                <div className="font-ml">{t(content.restart_title[0])} {SystemInfo}</div>
            </div>
        </div>
    );

}
export default MainPage;




